// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__q7nqi","topBottomGutter":"Layout_topBottomGutter__2TzRS"};